import { NavLink } from "react-router-dom";
import { Boxes, ScanLine, MapPin, Layers, ShieldCheck, Wrench, ClipboardCheck, BarChart3, LayoutGrid, LayoutDashboard, Store, FileClock } from "lucide-react";
import { useCam } from "./ctx";

// Secondary nav for the CAM module. Admin-only tabs (locations, categories, roles,
// audits) are hidden from non-admins, matching the report's role gating.
const TABS = [
  { to: "/cam/dashboard",   label: "Dashboard",   icon: LayoutDashboard },
  { to: "/cam",             label: "Inventory",   icon: Boxes,          end: true },
  { to: "/cam/lab",         label: "Lab view",    icon: LayoutGrid },
  { to: "/cam/scan",        label: "Scan",        icon: ScanLine },
  { to: "/cam/maintenance", label: "Work orders", icon: Wrench },
  { to: "/cam/vendors",     label: "Vendors",     icon: Store },
  { to: "/cam/amc",         label: "AMC",         icon: FileClock },
  { to: "/cam/audits",      label: "Audits",      icon: ClipboardCheck, adminOnly: true },
  { to: "/cam/locations",   label: "Locations",   icon: MapPin,         adminOnly: true },
  { to: "/cam/categories",  label: "Categories",  icon: Layers,         adminOnly: true },
  { to: "/cam/roles",       label: "Access",      icon: ShieldCheck,    adminOnly: true },
  { to: "/cam/reports",     label: "Reports",     icon: BarChart3 },
];

export default function CamNav() {
  const { can } = useCam();
  const tabs = TABS.filter((t) => !t.adminOnly || can.admin);
  return (
    <div className="flex gap-1 overflow-x-auto touch-scroll pb-1 -mx-1 px-1" data-testid="cam-nav">
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-zinc-900 text-white dark:bg-white dark:text-zinc-900 shadow-sm"
                  : "bg-white/60 dark:bg-white/5 hover:bg-white text-foreground/75"
              }`
            }
          >
            <Icon className="h-4 w-4" strokeWidth={1.75} />
            {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
